import React, { useEffect } from "react";
import { Button, Row, Col, Table } from "react-bootstrap";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import * as cartSlice from "../../../../redux/slices/cartSlice"; // Import the cartSlice
import * as customizeSlice from "../../../../redux/slices/customizeSlice";

const CustomizeCartDetails = ({ selectedCart }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const { cartDetails } = useSelector((state) => state.customizeSlice); // Updated to cartSlice

  useEffect(() => {
    if (params?.id) {
      dispatch(customizeSlice.getCartDetails(params?.id, navigate));
    }
  }, [params?.id]);
// console.log(cartDetails,"cartDetails")
  return (
    <div className="">
       <div className="text-left mt-4">
        <Button
          style={{ backgroundColor: "#e8783d", border: "none" }}
          onClick={() => navigate(-1)} // Go back to the previous page
        >
          Back
        </Button>
      </div>
      <h1 className="text-center">Trip Details</h1>
      <Row className="g-3">
        {/* User Details */}
        <h5>User Details:</h5>
        <Col xs={12} md={6} lg={4}>
          <p>
            <strong>Name:</strong> {cartDetails?.user?.first_name || "-"}
          </p>
        </Col>
        <Col xs={12} md={6} lg={4}>
          <p>
            <strong>Email:</strong> {cartDetails?.user?.email || "-"}
          </p>
        </Col>
        <Col xs={12} md={6} lg={4}>
          <p>
            <strong>Mobile Number:</strong>{" "}
            {cartDetails?.user?.mobile_no || "-"}
          </p>
        </Col>
        <hr />
        <h5>Trip Basic Details:</h5>
        <Col xs={12} md={6} lg={4}>
          <p>
            <strong>Trip ID:</strong> {cartDetails?.id|| "-"}
          </p>
        </Col>{" "}
        
        <Col xs={12} md={6} lg={4}>
          <p>
            <strong>Destination Name:</strong>{" "}
            {cartDetails?.destination_point?.destination_name|| "-"}
          </p>
        </Col>
        <Col xs={12} md={6} lg={4}>
          <p>
            <strong>Trip Name:</strong> {cartDetails?.trip_name|| "-"}
          </p>
        </Col>
        <Col xs={12} md={6} lg={4}>
          <p>
            <strong>Vehicle Name:</strong>{" "}
            {cartDetails?.vehicle_type?.type_name|| "-"}
          </p>
        </Col>
        <Col xs={12} md={6} lg={4}>
          <p>
            <strong>Pickup Point:</strong>{" "}
            {cartDetails?.pickup_point?.pickup_name|| "-"}
          </p>
        </Col>
        <Col xs={12} md={6} lg={4}>
          <p>
            <strong>Pickup Time:</strong> {cartDetails?.pickup_time?.time_slot|| "-"}
          </p>
        </Col>{" "}
        <Col xs={12} md={6} lg={4}>
          <p>
            <strong>Drop Point:</strong> {cartDetails?.drop_point?.drop_name|| "-"}
          </p>
        </Col>
        <Col xs={12} md={6} lg={4}>
          <p>
            <strong>Adult:</strong> {cartDetails?.adult|| "-"}
          </p>
        </Col>{" "}
        <Col xs={12} md={6} lg={4}>
          <p>
            <strong>Child :</strong> {cartDetails?.child}
          </p>
        </Col>{" "}
        <Col xs={12} md={6} lg={4}>
          <p>
            <strong>Room :</strong> {cartDetails?.room}
          </p>
        </Col>
        <Col xs={12} md={6} lg={4}>
          <p>
            <strong>Price :</strong> ₹{cartDetails?.price}
          </p>
        </Col>
        <Col xs={12} md={6} lg={4}>
          <p>
            <strong>Total Km:</strong> {cartDetails?.total_km || "-"}
          </p>
        </Col>
        <Col xs={12} md={6} lg={4}>
  <p>
    <strong>Start Date:</strong>{" "}
    {cartDetails?.start_date ? moment(cartDetails.start_date).format("DD-MM-YY") : "-"}
  </p>
</Col>
<Col xs={12} md={6} lg={4}>
  <p>
    <strong>End Date:</strong>{" "}
    {cartDetails?.end_date ? moment(cartDetails.end_date).format("DD-MM-YY") : "-"}
  </p>
</Col>
        <hr></hr>
        <h5>Passenger Details:</h5>
        <div className="table-responsive">
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Age</th>
                <th>Gender</th>
              </tr>
            </thead>
            <tbody>
              {cartDetails?.passengers?.map((pkg, index) => (
                <tr key={pkg.id}>
                  <td>{index + 1}</td>
                  <td>{pkg?.name}</td>
                  <td>{pkg?.age}</td>
                  <td>{pkg?.gender}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        <hr />
        {cartDetails?.packages && cartDetails.packages.length > 0 && (
          <>
            <h5>Package Details:</h5>
            <div className="table-responsive">
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Package Name</th>
                    <th>Description</th>
                    {/* <th>Price</th>
                    <th>Days</th>
                    <th>Adult Price</th>
                    <th>Child Price</th> */}
                  </tr>
                </thead>
                <tbody>
                  {cartDetails.packages.map((pkg, index) => (
                    <tr key={pkg.id}>
                      <td>{index + 1}</td>
                      <td>{pkg.package_details.package_name}</td>
                      <td>{pkg.package_details.small_description}</td>
                      {/* <td>₹{pkg.package_details.price}</td>
                      <td>{pkg.package_details.number_of_days}</td>
                      <td>₹{pkg.package_details.price_per_adult}</td>
                      <td>₹{pkg.package_details.price_per_child}</td> */}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            <hr />
          </>
        )}
        <h5>Travel Notes:</h5>
        <div className="table-responsive">
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Type</th>
                <th>Booking Name</th>
                <th>Confirmation Number</th>
              </tr>
            </thead>
            <tbody>
              {cartDetails?.travel_notes?.buses?.map((bus, index) => (
                <tr key={`bus-${index}`}>
                  <td>Bus</td>
                  <td>{bus?.bookingName || "-"}</td>
                  <td>{bus?.confirmationNumber || "-"}</td>
                </tr>
              ))}
              {cartDetails?.travel_notes?.trains?.map((train, index) => (
                <tr key={`train-${index}`}>
                  <td>Train</td>
                  <td>{train?.bookingName || "-"}</td>
                  <td>{train?.confirmationNumber || "-"}</td>
                </tr>
              ))}
              {cartDetails?.travel_notes?.flights?.map((flight, index) => (
                <tr key={`flight-${index}`}>
                  <td>Flight</td>
                  <td>{flight?.bookingName || "-"}</td>
                  <td>{flight?.confirmationNumber || "-"}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        {/* Trip Ideas */}
        {cartDetails?.trip_ideas?.length > 0 && (
          <>
            <h5>Trip Idea Details:</h5>
            <div className="table-responsive">
            <Table striped bordered hover>
                <thead>
                  <tr>
                    {/* <th>#</th> */}
                    <th>Title</th>
                    <th>Description</th>
                    <th>Link</th>
                  </tr>
                </thead>
                <tbody>
                  {cartDetails?.trip_ideas?.map((pkg, index) => (
                    <tr>
                      <td>{pkg?.title}</td>
                      <td>{pkg?.description}</td>
                      <td>{pkg?.link}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </>
        )}
      </Row>
     
    </div>
  );
};

export default CustomizeCartDetails;
